const lookfyPage = document.getElementById('lookfy-page')

if (lookfyPage) {
  document.querySelector('body').classList.add('lookfy-page')
  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        if (mutation.removedNodes.length > 0) {
          const addedHotspotId = mutation.target.dataset.id
          const addedHotspot = document.querySelector(`.kt-tooltip[data-id="${addedHotspotId}"]`)

          if (addedHotspot) {
            const hasQuickbuy = addedHotspot.querySelector('quick-add-trigger')

            if (!hasQuickbuy) {
              const productHandle = addedHotspot.querySelector('.hotspot-item-detail ').dataset.handle
              const quickBuy = document.createElement('div')
              quickBuy.innerHTML = `
                <quick-add-trigger 
                  class="product-card__quick-add loading"
                  data-product-card-el="quick-add"
                  data-product-handle="${productHandle}"
                  data-initialized="true"
                  data-preorder-handle="${productHandle}"
                >
                  <button class="dialog-quick-add__trigger" type="button" data-quick-add-trigger-el="trigger" aria-label="open quick add modal">
                    Quick Add
                  </button>
                </quick-add-trigger>
              `
              const innerBlock = addedHotspot.querySelector('.hotspot-item-content')
              if (innerBlock) {
                innerBlock.appendChild(quickBuy)
              }
            }
          }
        }
      }
    }
  }

  const observer = new MutationObserver(callback)
  observer.observe(lookfyPage, { attributes: true, childList: true, subtree: true })
}
